import { Injectable } from '@angular/core';

export interface FocusEvent {
  focusedOut: boolean;
  focusedIn: boolean;
  date: string;
  questionId: string;
}

export interface ReportedQuestion {
  questionId: string;
  reason: string;
  suggestion: string;
}

export interface MonitoringEvent {
  monitoringName: string;
  timestamp?: string;
  isExternalHardware?:boolean
}

@Injectable({
  providedIn: 'root'
})
export class ExaminationEventService {
  private focusEventsBySection: { [sectionId: string]: FocusEvent[] } = {};
  private reportedQuestionsBySection: { [sectionId: string]: ReportedQuestion[] } = {};
  private monitoringEventsBySection: { [sectionId: string]: MonitoringEvent[] } = {};

  constructor() {}

  addFocusEvent(sectionId: string, event: FocusEvent) {
    if (!this.focusEventsBySection[sectionId]) {
      this.focusEventsBySection[sectionId] = [];
    }
    this.focusEventsBySection[sectionId].push(event);
  }

  getFocusEvents(sectionId: string): FocusEvent[] {
    return this.focusEventsBySection[sectionId] || [];
  }

  clearFocusEvents(sectionId: string) {
    this.focusEventsBySection[sectionId] = [];
  }

  addReportedQuestion(sectionId: string, reportedQuestion: ReportedQuestion) {
    if (!this.reportedQuestionsBySection[sectionId]) {
      this.reportedQuestionsBySection[sectionId] = [];
    }
    
    const existingIndex = this.reportedQuestionsBySection[sectionId].findIndex(
      q => q.questionId === reportedQuestion.questionId
    );
    
    if (existingIndex >= 0) {
      // Update existing report
      this.reportedQuestionsBySection[sectionId][existingIndex] = reportedQuestion;
    } else {
      // Add new report
      this.reportedQuestionsBySection[sectionId].push(reportedQuestion);
    }
  }

  getReportedQuestions(sectionId: string): ReportedQuestion[] {
    return this.reportedQuestionsBySection[sectionId] || [];
  }

  clearReportedQuestions(sectionId: string) {
    this.reportedQuestionsBySection[sectionId] = [];
  }

  addMonitoringEvent(sectionId: string, event: MonitoringEvent) {
    if (!this.monitoringEventsBySection[sectionId]) {
      this.monitoringEventsBySection[sectionId] = [];
    }
    this.monitoringEventsBySection[sectionId].push(event);
  }

  getMonitoringEvents(sectionId: string): MonitoringEvent[] {
    return this.monitoringEventsBySection[sectionId] || [];
  }

  clearMonitoringEvents(sectionId: string) {
    this.monitoringEventsBySection[sectionId] = [];
  }

  clearAllData() {
    this.focusEventsBySection = {};
    this.reportedQuestionsBySection = {};
    this.monitoringEventsBySection = {};
  }
}